import React from 'react';
import { BrandColor } from '@styleseat/brand';

type FacebookLogoCircleProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FacebookCircleIcon = ({
  width = 24,
  height = 24,
  color = BrandColor.BackInBlack,
}: FacebookLogoCircleProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 42 43"
    fill={color}
  >
    <path
      d="M42 21.0278C42 31.629 34.1374 40.3929 23.924 41.8155C22.9687 41.9485 21.9916 42.0174 21 42.0174C19.8548 42.0174 18.7314 41.9255 17.6358 41.749C7.63769 40.1403 0 31.4743 0 21.0266C0 9.43441 9.40201 0.0371094 21 0.0371094C32.598 0.0371094 42 9.43441 42 21.0266V21.0278Z"
      fill="#1C1C1B"
    />
    <path
      d="M23.3948 16.3021V20.9815H28.9988L28.1115 27.2863H23.3948V41.8106C22.4488 41.9467 21.4813 42.0172 20.4994 42.0172C19.3654 42.0172 18.253 41.9232 17.1681 41.7426V27.2863H12V20.9815H17.1681V15.2569C17.1681 11.7044 19.9558 8.82349 23.396 8.82349V8.8272C23.4056 8.8272 23.4151 8.82349 23.4247 8.82349H29V14.2747H25.3574C24.2737 14.2747 23.396 15.1814 23.396 16.3009L23.3948 16.3021Z"
      fill="white"
    />
  </svg>
);
